import { useQuery } from "@apollo/client";

import { GqlPlannerV2ShiftsGetAllArgs } from "~/__generated__";

import { FieldworkerShiftsScreen_GetAllDocument } from "../queries.generated";

export default function useFieldworkerShiftsScreen_GetAll(params: GqlPlannerV2ShiftsGetAllArgs) {
    const { data, loading, error } = useQuery(FieldworkerShiftsScreen_GetAllDocument, {
        variables: { params },
    });

    return {
        loading,
        error,
        data: data?.plannerV2ShiftGetAll.data,
    };
}
